// This is the single point to build payload for all algo-related abTests
// It's already passed to all listings requests to algo
import { EXPERIMENTS } from '../../../../../configuration/abTests';
import { ALLOCATION } from '../../../hooks/useExperiment/constants';

const getAlgoAbTestsConfig = (abTests) =>
    Object.values(EXPERIMENTS).reduce((acc, test) => {
        const group = abTests[test];
        return { ...acc, [test]: group === ALLOCATION.VERSION_B };
    }, {});

export default getAlgoAbTestsConfig;
